<div class="form"
     [ngClass]="{'is-overlay': (isLoadingCities$ | async), '_postcode': postcodeAddress$ | async}"
     [formGroup]="form"
>
  <div class="form__overlay" *ngIf="isLoadingCities$ | async">
    <mat-spinner color="accent"></mat-spinner>
  </div>

  <div class="form__row">
    <div class="form__col _md">
      <app-ez-input>
        <input appEzInput
               type="text"
               formControlName="postCode"
               name="postCode"
               data-testid="postCode"
        >
        <ng-container ezLabel i18n="@@Postcode">Postcode</ng-container>

        <ng-container ezError *ngIf="form.controls.postCode.hasError('required') && (form.controls.postCode.dirty || form.controls.postCode.touched)" i18n="@@ErrorMessageRequired">Required</ng-container>
        <ng-container ezError *ngIf="form.controls.postCode.hasError('min') && (form.controls.postCode.dirty || form.controls.postCode.touched)" i18n="@@ErrorMessageMinLength">Minimum length {{ form.controls.postCode.errors!['min'].min }}</ng-container>
        <ng-container ezError *ngIf="form.controls.postCode.hasError('max') && (form.controls.postCode.dirty || form.controls.postCode.touched)" i18n="@@ErrorMessageMaxLength">Maximum length {{ form.controls.postCode.errors!['max'].max }}</ng-container>
        <ng-container ezError *ngIf="form.controls.postCode.hasError('pattern') && (form.controls.postCode.dirty || form.controls.postCode.touched)" i18n="@@ErrorMessagePattern">Incorrect format</ng-container>
      </app-ez-input>
    </div>
  </div>

  <ng-container *ngIf="postcodeAddress$ | async as postcodeAddress">
    <ng-container *ngIf="postcodeAddress.length">
      <div class="form__col _md">
        <mat-form-field appearance="outline">
          <mat-label><span i18n="@@AddressLine">Address Line</span> 1</mat-label>
          <mat-select [formControl]="streetControl">
            <mat-option
              *ngFor="let address of postcodeAddress; let i = index"
              value="{{ address.building }}, {{ address.street }}, {{ address.city }}"
              (onSelectionChange)="onChangeAddress(address, $event)"
            >{{ address.building }}, {{ address.street }}, {{ address.city }}</mat-option>
          </mat-select>
          <mat-error *ngIf="form.controls.street.hasError('required')" i18n="@@ErrorMessageRequired">Required</mat-error>
        </mat-form-field>
      </div>

      <div class="form__col _md">
        <app-ez-input>
          <input appEzInput
                 type="text"
                 formControlName="flat"
                 name="flat"
                 data-testid="flat"
          >
          <ng-container ezLabel><span i18n="@@AddressLine">Address Line</span> 2</ng-container>
        </app-ez-input>
      </div>
    </ng-container>
  </ng-container>
</div>
